import z from 'zod'
import { blankableDecimalSchema, decimalSchema } from '../../utils/schema'

export const coinBalanceSchema = z.object({
  coin: z.string(),
  transferBalance: decimalSchema,
  walletBalance: decimalSchema,
  bonus: blankableDecimalSchema,
})

export const earnPositionSchema = z.object({
  coin: z.string(),
  productId: z.string(),
  amount: decimalSchema,
  totalPnl: decimalSchema,
  claimableYield: decimalSchema,
  id: z.string(),
  status: z.string(),
  orderId: z.string(),
  estimateRedeemTime: z.string(),
  estimateStakeTime: z.string(),
  estimateInterestCalculationTime: z.string(),
  settlementTime: z.string(),
})

const walletCoinSchema = z.object({
  availableToBorrow: blankableDecimalSchema,
  bonus: blankableDecimalSchema,
  accruedInterest: blankableDecimalSchema,
  availableToWithdraw: blankableDecimalSchema,
  totalOrderIM: blankableDecimalSchema,
  equity: blankableDecimalSchema,
  totalPositionMM: blankableDecimalSchema,
  usdValue: blankableDecimalSchema,
  spotHedgingQty: blankableDecimalSchema,
  unrealisedPnl: blankableDecimalSchema,
  collateralSwitch: z.boolean(),
  borrowAmount: blankableDecimalSchema,
  totalPositionIM: blankableDecimalSchema,
  walletBalance: blankableDecimalSchema,
  cumRealisedPnl: blankableDecimalSchema,
  locked: blankableDecimalSchema,
  marginCollateral: z.boolean(),
  coin: z.string(),
})

export const walletBalanceSchema = z.object({
  totalEquity: decimalSchema,
  accountIMRate: blankableDecimalSchema,
  accountIMRateByMp: blankableDecimalSchema,
  totalMarginBalance: blankableDecimalSchema,
  totalInitialMargin: blankableDecimalSchema,
  totalInitialMarginByMp: blankableDecimalSchema,
  accountType: z.string(),
  totalAvailableBalance: blankableDecimalSchema,
  accountMMRate: blankableDecimalSchema,
  accountMMRateByMp: blankableDecimalSchema,
  totalPerpUPL: blankableDecimalSchema,
  totalWalletBalance: blankableDecimalSchema,
  accountLTV: blankableDecimalSchema,
  totalMaintenanceMargin: blankableDecimalSchema,
  totalMaintenanceMarginByMp: blankableDecimalSchema,
  coin: walletCoinSchema.array(),
})
